var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTorus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16667 0.5H0.5V5.14593H4.16667V15.4333H8.83333V5.14593V0.5H4.16667ZM14.5007 2.82296C14.5007 4.1059 13.456 5.14593 12.1673 5.14593C10.8787 5.14593 9.83398 4.1059 9.83398 2.82296C9.83398 1.54002 10.8787 0.5 12.1673 0.5C13.456 0.5 14.5007 1.54002 14.5007 2.82296Z",
    fill: "#3A95FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTorus);
export default __webpack_public_path__ + "static/media/torus.8b09901323333aa83b346ffae9e29d60.svg";
export { ForwardRef as ReactComponent };